import styled from 'styled-components'

export const GroupCreationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 24px;
`

export const MainContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
`

export const InputSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
`

export const FilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  margin-right: 24px;
  width: 100%;
`

export const TableSection = styled.div`
  flex: 6; /* Use flex-basis for 60% ratio */
  min-width: 0; /* Prevent content from breaking flex layout */
`

export const AnalyticsSection = styled.div`
  flex: 4; /* Use flex-basis for 40% ratio */
  display: flex;
  flex-direction: column;
  gap: 24px;
`
export const GroupDrawerText = styled.div`
  margin-bottom: 10px;
  font-weight: 600;
`
